import styled from 'styled-components'
import Person from './Person'

export default function People( { people } ) {
  return (
    <StyledPeopleGrid>
      { people.map( person => (
        <Person
          key={ person.id }
          person={ person }
        />
      ) ) }
    </StyledPeopleGrid>
  )
}

const StyledPeopleGrid = styled.div`
  --gap: calc( 2 * var( --grid-gutter ) );
  display: grid;
  grid-template-columns: 1fr;
  gap: var( --gap );

  @media ( min-width: 540px ) {
    grid-template-columns: repeat( 2, 1fr );
  }
  
  @media ( min-width: 750px ) {
    grid-template-columns: repeat( 3, 1fr );
  }
  
  @media ( min-width: 1100px ) {
    grid-template-columns: repeat( 4, 1fr );
  }
`
